export default __webpack_public_path__ + "static/flow-video-65a674fa79c4b19476f1989146ade751.png";